import React from 'react';
import styled from 'styled-components';
import { Table } from '@material-ui/core';
const StyledTable = styled(Table) `
  .nowrap {
    white-space: nowrap;
  }
`;
const StyledHeader = styled.div `
  display: flex;
  align-items: center;
  .header-label {
    margin-right: 12px;
    margin-bottom: 20px;
  }
  .action-buttons {
    display: flex;
    margin-left: 8px;
  }
  .saving-status {
    margin-top: 3px;
    min-height: 19px;
    display: flex;
    justify-content: center;
    .save-label {
      margin-left: 8px;
    }
  }
`;
/**
 * @deprecated
 */
const FormDataEditor = ({ formTemplateVersion }) => {
    return React.createElement(React.Fragment, null);
    // const [openFormDialog, setOpenFormDialog] = useState(false);
    // const [editFormData, setEditFormData] = useState<FormData<any>>();
    // const formSchemaVersion = formTemplateVersion.formSchemaVersion;
    // const { formDataList, getFormData } = useFindFormSchemaData(
    //   formSchemaVersion.formSchemaId
    // );
    // useEffect(() => getFormData(), [getFormData]);
    // return (
    //   <FormProvider
    //     // entitySchema={formSchemaVersion.config}
    //     formStateNode={formTemplateVersion.config}
    //   >
    //     <PageTemplateDashboard>
    //       <PageTemplateCardOver>
    //         <CardContent>
    //           <StyledHeader>
    //             <Button
    //               variant='outlined'
    //               endIcon={<Add />}
    //               onClick={() => {
    //                 setEditFormData(undefined);
    //                 setOpenFormDialog(true);
    //               }}
    //             >
    //               Add
    //             </Button>
    //           </StyledHeader>
    //         </CardContent>
    //         <Divider />
    //         <TableContainer>
    //           <StyledTable stickyHeader>
    //             <TableHead>
    //               <TableRow>
    //                 <TableCell>ID</TableCell>
    //                 {formSchemaVersion.config.columns.map(column => (
    //                   <TableCell key={column.name} className='nowrap'>
    //                     {column.displayName}
    //                   </TableCell>
    //                 ))}
    //                 <TableCell>Created</TableCell>
    //                 <TableCell></TableCell>
    //               </TableRow>
    //             </TableHead>
    //             <TableBody>
    //               {formDataList?.data.map(item => (
    //                 <TableRow
    //                   hover
    //                   key={item.id}
    //                   onClick={() => {
    //                     setEditFormData(item);
    //                     setOpenFormDialog(true);
    //                   }}
    //                 >
    //                   <TableCell>{item.id}</TableCell>
    //                   {formSchemaVersion.config.columns.map(column => (
    //                     <TableCell key={column.name} className='nowrap'>
    //                       {(() => {
    //                         const data = item[column.name] || '';
    //                         switch (column.type) {
    //                           // TODO: handle any special column types
    //                           default:
    //                             if (Array.isArray(data)) {
    //                               return data.join(', ');
    //                             } else if (typeof data === 'boolean') {
    //                               return data ? <Check /> : '';
    //                             } else {
    //                               return data;
    //                             }
    //                         }
    //                       })()}
    //                     </TableCell>
    //                   ))}
    //                   <TableCell className='nowrap'>
    //                     {format(item.created, 'MMM d, yyyy h:mm a')}
    //                   </TableCell>
    //                   <TableCell>
    //                     <IconButton size='small'>
    //                       <Delete />
    //                     </IconButton>
    //                   </TableCell>
    //                 </TableRow>
    //               ))}
    //             </TableBody>
    //           </StyledTable>
    //         </TableContainer>
    //       </PageTemplateCardOver>
    //       {openFormDialog && (
    //         <FormDialog
    //           open
    //           formData={editFormData}
    //           onCancel={() => {
    //             setOpenFormDialog(false);
    //             getFormData();
    //           }}
    //           onSubmit={() => {
    //             setOpenFormDialog(false);
    //             getFormData();
    //           }}
    //         />
    //       )}
    //     </PageTemplateDashboard>
    //   </FormProvider>
    // );
};
export default FormDataEditor;
//# sourceMappingURL=FormDataEditor.js.map